import React, { useState } from "react";
import PhotoField from "./PhotoField";

export const IN = "min-h-[48px] rounded border border-erf-borderCream px-3 bg-white text-base w-full";
export const BTN = "min-h-[48px] px-4 rounded-sm text-sm font-semibold border border-erf-borderCream";
export const errMsg = (e) => e?.response?.data?.detail?.message || "That didn't work.";

// Small mobile-first form: fields [{ key, label, type?: "text"|"date"|"number"|"select"|"textarea"|"checkbox", options? }].
export default function QuickForm({ id, fields, initial, submitLabel, onSubmit }) {
  const [v, setV] = useState(initial);
  const [err, setErr] = useState("");
  const set = (k, x) => setV({ ...v, [k]: x });
  const submit = (e) => {
    e.preventDefault();
    onSubmit(v).then(() => { setV(initial); setErr(""); }).catch((x) => setErr(errMsg(x)));
  };
  const field = (f) => {
    const tid = `${id}-${f.key}`;
    if (f.type === "select") return <select className={IN} value={v[f.key]} onChange={(e) => set(f.key, e.target.value)} data-testid={tid}>{f.options.map((o) => (typeof o === "string" ? { value: o, label: o.replace(/_/g, " ") } : o)).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</select>;
    if (f.type === "textarea") return <textarea rows={3} className={`${IN} py-2`} value={v[f.key]} onChange={(e) => set(f.key, e.target.value)} data-testid={tid} />;
    if (f.type === "photos") return <PhotoField pid={f.pid} value={v[f.key]} onChange={(ids) => set(f.key, ids)} testId={tid} />;
    if (f.type === "checkbox") return <input type="checkbox" className="h-6 w-6" checked={!!v[f.key]} onChange={(e) => set(f.key, e.target.checked)} data-testid={tid} />;
    return <input type={f.type || "text"} className={IN} value={v[f.key]} onChange={(e) => set(f.key, e.target.value)} data-testid={tid} />;
  };
  return (
    <form onSubmit={submit} className="grid gap-2 sm:grid-cols-2 border border-erf-borderCream rounded bg-white p-3" data-testid={`${id}-form`}>
      {fields.map((f) => <label key={f.key} className={`text-xs flex ${f.type === "checkbox" ? "items-center gap-2 min-h-[48px]" : "flex-col gap-1"} ${f.wide ? "sm:col-span-2" : ""}`}>{f.label}{field(f)}</label>)}
      {err && <p role="alert" className="text-sm text-red-700 sm:col-span-2" data-testid={`${id}-error`}>{err}</p>}
      <button type="submit" className={`${BTN} bg-erf-dark text-white sm:col-span-2`} data-testid={`${id}-submit`}>{submitLabel}</button>
    </form>
  );
}
